export default {
    title: "Conjunto de Dados",
    list: {
        confirm_delete_title: "Gostaria de excluir",
        confirm_delete_body:
            "Para evitar erros inesperados, garanta que seu conjunto não está sendo usado em nenhuma automação/campanha.",
        empty_alert: "Você ainda não possui nenhum Conjunto de Dados,",
        create_first: "crie o primeiro agora!",
        filter_placeholder: "Filtrar por Nome de Conjunto de Dados",
        create_new: "Criar Novo Conjunto de Dados",
        edit_tooltip: "Editar conjunto de dados",
        delete_tooltip: "Excluir conjunto de dados",
        no_results: "Nenhum conjunto de dados encontrado com",
        error_loading: "Erro ao carregar os conjuntos de dados.",
        error_deleting: "Erro ao excluir o conjunto de dados.",
        delete_success: "Conjunto de Dados excluído com Sucesso!",
    },
    form: {
        edit_title: "Editar Conjunto de Dados",
        new_title: "Novo Conjunto de Dados",
        back: "Voltar",
        basic_info: "Informações Básicas",
        name_label: "Nome do Conjunto de Dados",
        name_placeholder: "Ex: Produtos em Promoção",
        description_label: "Descrição",
        description_placeholder:
            "Descreva o propósito deste conjunto de dados...",
        characters: "caracteres",
        data_structure: "Estrutura dos Dados",
        data_structure_help:
            "Configure as colunas e valores do seu conjunto de dados",
        edit_with_ai: "Editar com IA",
        processing: "Processando...",
        key_column: "Chave",
        column_name_placeholder: "Nome da Coluna",
        default_value: "Valor Padrão",
        value_placeholder: "Valor",
        new_key_placeholder: "Nova Chave",
        validation_empty_dataset:
            "Adicione pelo menos uma linha ao conjunto de dados.",
        validation_empty_headers:
            "Todos os nomes de colunas devem ser preenchidos",
        validation_name_required: "Campo nome não pode ficar vazio",
        validation_description_max:
            "Campo descrição não pode exceder 250 caracteres",
        error_loading: "Erro ao carregar o conjunto de dados.",
        error_saving: "Erro ao salvar o conjunto de dados.",
        edit_success: "Conjunto de Dados Editado com Sucesso!",
        create_success: "Conjunto de Dados Criado com Sucesso!",
        saving: "Salvando...",
        save_button: "Salvar Conjunto de Dados",
        cancel: "Cancelar",
        ai_modal_title: "Gerar/Editar Dataset com IA",
        ai_modal_current: "Dataset Atual",
        ai_modal_columns: "Colunas:",
        ai_modal_rows: "Linhas:",
        ai_modal_instructions: "Instruções para a IA",
        ai_modal_placeholder:
            "Descreva o que você gostaria de criar ou modificar. Por exemplo:\n\nCRIAR NOVO DATASET:\n- Crie um dataset de produtos de tecnologia com colunas: Nome, Categoria, Preço, Marca, Estoque. Gere 15 produtos variados\n- Gere um dataset de clientes com 20 registros incluindo nome, email, telefone, cidade, data_cadastro\n- Crie um dataset de promoções com colunas: Titulo, Desconto, Validade, Categoria, Codigo\n\nMODIFICAR EXISTENTE:\n- Adicione uma coluna 'Preço' com valores entre R$ 10 e R$ 100\n- Crie 5 novas linhas com produtos de tecnologia\n- Modifique a coluna 'Categoria' para incluir 'Eletrônicos'\n\nIMPORTAR DADOS:\n- Cole dados CSV ou JSON aqui para importar\n\nA IA pode gerar datasets completamente novos ou modificar o existente!",
        ai_loading_messages: [
            "Analisando suas instruções...",
            "Processando o dataset atual...",
            "Gerando dados com IA...",
            "Aplicando as modificações...",
            "Finalizando o dataset...",
            "Quase pronto...",
            "Só mais um momento...",
        ],
        ai_modal_generate: "Gerar Dataset",
        validation_duplicate_key: "Erro: A chave '{0}' já existe.",
        ai_success: "Dataset gerado/atualizado com IA!",
        ai_error_process: "Erro ao processar com IA",
        ai_error_connection: "Erro na comunicação com o servidor",
        ai_error_generic:
            "Erro ao processar as mudanças com IA. Tente novamente.",
    },
};
